import { z } from 'zod'

export const TranscriptSegmentSchema = z.object({
  speaker: z.string(),
  speakerName: z.string(),
  speakerUsername: z.string().optional(),
  startMs: z.number().int().nonnegative(),
  endMs: z.number().int().nonnegative(),
  text: z.string(),
  confidence: z.number().optional(),
})
export type TranscriptSegment = z.infer<typeof TranscriptSegmentSchema>

export const TranscriptSchema = z.object({
  meetingId: z.string(),
  recordingId: z.string(),
  language: z.string(),
  createdAt: z.string(),
  // Абсолютное время нуля таймлайна: anchor + startMs = фактическое время реплики.
  anchor: z.string().optional(),
  segments: z.array(TranscriptSegmentSchema),
})
export type Transcript = z.infer<typeof TranscriptSchema>
